module.exports = __webpack_public_path__ + "img/0024.f350cb8e.jpg";